import { Injectable } from '@angular/core';
import { ProviderResponseModel } from 'src/app/shared/models/common/api-status';
import { throwError } from 'rxjs';
import { Messages } from '../../messages/messages';
import * as moment from 'moment';
import { Constants, ModuleConstants } from '../../constants/constants';
import { NgxPubSubService } from '@pscoped/ngx-pub-sub';
import { StorageProvider } from '../../http/storage-service';
import { LoggingService } from './logging.service';
@Injectable({
  providedIn: 'root'
})
export class CommonUtilsService {
  projectData: any;
  searchData: any;
  gridPageSize: any;
  constructor(private eventService: NgxPubSubService, private storageProvider: StorageProvider, private loggingService: LoggingService) { }

  /**
   * Desc: Function called to extract server data
   * @param:response data
   */
  public extractData(res: any): any {
    if (res !== undefined || res !== null) {
      return this.getProviderResObj(res.isSuccess, res.isUserConfirmationRequired, res, res.statusMessage);
    } else {
      return this.getProviderResObj(false, false, res, Messages.Dialog_Message_Error);
    }
  }

  /**
   * Return API response in custom format
   * @param status api status
   * @param isUserConfirmationRequired api status for showing confirm dialog
   * @param data api data
   * @param message api message
   */
  public getProviderResObj(status: any, isUserConfirmationRequired: any, data?: any, message?: any): any {
    const provResponseObj: ProviderResponseModel = new ProviderResponseModel();
    provResponseObj.status = status;
    provResponseObj.data = data === undefined ? '' : data.data;
    provResponseObj.message = message === undefined ? '' : message;
    provResponseObj.isUserConfirmationRequired = isUserConfirmationRequired === undefined ? false : isUserConfirmationRequired;

    return provResponseObj;
  }

  /**
   * Desc: Function called to throw error
   * @param err error code
   */
  public catchError(err: any): any {

    // Not throw error if 401 (Unauthorized)
    // 401 is handled on interceptor
    if (err.status !== 401) {
      if (err.name === 'TimeoutError') {
        this.eventService.publishEvent(Constants.ConnectionTimeoutErrorEvent, true);
      } else {
        this.loggingService.logException(err); // logging exception
        return throwError(err);
      }
    }
  }

  /**
   * Desc: Function called to catch error for fire and forgot api's
   * @param err error code
   */
  public catchFireForgotError(err: any): any {
    // Not throw error if 401 (Unauthorized)
    // 401 is handled on interceptor
    if (err.status !== 401) {
      if (!(err.name === 'TimeoutError')) {
        this.loggingService.logException(err); // logging exception
        return throwError(err);
      }
    }
  }

  /**
   * Method to convert date string to date object
   * @param dateStr input date string
   */
  convertStringToDate(dateStr) {
    if (dateStr != null) {
      return moment(dateStr).toDate();
    }
    return dateStr;
  }

  /**
   * Method will convert date event to date string
   * @param dateEvent date event from picker
   */
  convertStrDate(dateEvent) {
    if (dateEvent != null) {
      return moment(dateEvent).toISOString();
    }
  }

  /**
   * Desc:Function to format date in YyyyMmDd format.
   * @param date :given date.
   */
  public formatDateToYyyyMmDd(date) {
    const d = new Date(date.getTime());
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  /**
   * Function will convert dateString to YyyyMmDd.
   * @param date : input date
   */
  public convertDateStringToYyyyMmDd(strDate: any): any {
    if (strDate != null && strDate !== '') {
      const date: any = new Date(strDate);
      let dd: any = date.getDate();
      let mm: any = date.getMonth() + 1;
      const yyyy = date.getFullYear();

      if (dd < 10) {
        dd = '0' + dd;
      }

      if (mm < 10) {
        mm = '0' + mm;
      }
      return [yyyy, mm, dd].join('-');
    }
    return strDate;
  }

  /**
   * Descp:Function to convert date string to mm/dd/yyyy format.
   * @param: str
   */
  convertStrToDateFormat(str: any) {
    if (str) {
      const date = new Date(str);
      const mnth = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return [mnth, day, date.getFullYear()].join('/');
    } else {
      return '';
    }
  }

  /**
   * Sets Searched Project Data
   * @param projectData : transaction id
   */
  setSearchedProjectData(projectData) {
    this.projectData = projectData;
    this.storageProvider.setSessionStorageData(Constants.SearchedProjectData, this.projectData);
  }

  /**
   * Gets searched project data
   * @returns : object
   */
  getSearchedProjectData() {
    if (this.projectData == null) {
      this.projectData = this.storageProvider.getSessionStorageData(Constants.SearchedProjectData);
    }
    return this.projectData;
  }

  /**
   * Sets Search Project Criteria
   * @param searchData : transaction id
   */
  setSearchProjectCriteria(searchData) {
    this.searchData = searchData;
    // this.storageProvider.setSessionStorageData(Constants.SearchedProjectData, this.projectData);
  }

  /**
   * Gets project criteria
   * @returns : object
   */
  getSearchProjectCriteria() {
    // if (this.searchData == null) {
    //   this.searchData = this.storageProvider.getSessionStorageData(Constants.SearchedProjectData);
    // }
    return this.searchData;
  }

  /**
   * Function will return browser name
   */
  getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1:
        return 'opera';
      case agent.indexOf('chrome') > -1:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  /**
   * Return 'Y' or 'N' based on boolean input
   * @param data data for conversion
   */
  getStringValForBool(data: any): any {
    if (data) {
      return 'Y';
    }
    return 'N';
  }


  /**
   * Sets global grid page size
   * @param gridPageSize : kendo grid page size
   */
  setGlobalGridPageSize(gridPageSize) {
    this.gridPageSize = gridPageSize;
    this.storageProvider.setSessionStorageData(Constants.UserPrefGridPageSize, this.gridPageSize);
  }

  /**
   * Gets global grid page size
   * @returns : object
   */
  getGlobalGridPageSize() {
    if (this.gridPageSize == null) {
      this.gridPageSize = this.storageProvider.getSessionStorageData(Constants.UserPrefGridPageSize);
    }
    return this.gridPageSize;
  }

  /**
   * Method to convert date to particular format
   * @param dateStr input date string
   * @param dateFormat output date format
   */
  convertStrDateToSpecificFormat(dateStr, dateFormat) {
    if (dateStr != null) {
      return moment(dateStr).format(dateFormat);
    }
  }

  /**
   * Description:Function will convert date to yyyy-mm-dd string.
   * @param inputDate date
   */
  public convertDateToYyyyMmDdString(inputDate: any): any {
    if (inputDate !== '') {
      let strDate: any = new Date(inputDate);
      let dd: any = strDate.getDate();
      let mm: any = strDate.getMonth() + 1;
      const yyyy = strDate.getFullYear();

      if (dd < 10) {
        dd = '0' + dd;
      }

      if (mm < 10) {
        mm = '0' + mm;
      }
      strDate = yyyy + '-' + mm + '-' + dd;
      return strDate;
    }
    return inputDate;
  }

  /**
   * Method to filter active status records
   * @param dataList  initial master records list
   */
  getActiveMasterRecords(dataList) {
    const activeStatus = 'Active';
    return dataList.filter((element: any) => element.status === activeStatus);
  }

  /**
   * Method to get warning message during export operation
   * @param exportRecordLimit:grid export operation limit
   */
  getMessageForExportLimit(exportRecordLimit) {
    const message = `Cannot export more than ${exportRecordLimit} records, please narrow down your search.`;
    return message;
  }

  /**
   * Method to get max limit for grid export actions.
   * @param optType:operation type(print,pdf,export)
   */
  getMaxLimitForExport(optType) {
    let exportRecordLimit = 1000;
    switch (optType) {
      case ModuleConstants.kendoGridExportPdfAction:
        exportRecordLimit = ModuleConstants.kendoGridExportPdfLimit;
        break;
      case ModuleConstants.kendoGridExportExcelAction:
        exportRecordLimit = ModuleConstants.kendoGridExportExcelLimit;
        break;
      case ModuleConstants.kendoGridExportPrintAction:
        exportRecordLimit = ModuleConstants.kendoGridExportPrintLimit;
        break;
    }
    return exportRecordLimit;
  }

  /**
   * Method to convert form group name to sentence case
   * @param keyName:current form control name
   * @returns name in sentence case
   */
  convertKeyToSentenceCase(keyName) {
    const result = keyName.replace(/([A-Z])/g, ' $1');
    const updatedText = result.charAt(0).toUpperCase() + result.slice(1);
    return updatedText;
  }

  getDateOnly(dateTime: string) {
    let dateOnly = null;
    if (dateTime) {
      const dateWithTime = new Date(dateTime);
      let year = dateWithTime.getFullYear();
      let month = dateWithTime.getMonth() + 1; // Since month index are 0 based you have to increment it by 1
      let day = dateWithTime.getDate();
      dateOnly = `${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}T00:00:00.000Z`;
    }

    return dateOnly;
  }
}
